import * as React from 'react'
import { createRoot } from 'react-dom/client';
import Slider from './components/slider/Slider'


export const renderSlider = (el, slides, onlyDots) => {
    if (!el) {
        el = document.querySelector('.image-video-slider')
    }
    if (el && slides.length > 0) {
        const root = createRoot(el);
        root.render(<Slider slides={slides} onlyDots={onlyDots} />);
    }
};
